<template>
  <div>
    <div style="height: 40px;display: flex;align-items: center">
      <RadioGroup v-model="type" @on-change="onChange">
        <Radio :label="0">今天</Radio>
        <Radio :label="1">自定义</Radio>
      </RadioGroup>
      <vxe-input v-if="type === 1" type="date" v-model="time" @change="search"></vxe-input>
    </div>
    <vxe-table
        style="margin-top: 10px"
        class="table-style"
        stripe
        align="center"
        highlight-hover-row
        border="inner"
        :loading="loading"
        :data="hisData"
        height="400"
    >
      <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
      <vxe-table-column field="name" title="船舶名称" show-overflow></vxe-table-column>
      <vxe-table-column field="mmsi" title="MMSI" show-overflow></vxe-table-column>
      <vxe-table-column field="createTime" title="查询时间" show-overflow>
        <template slot-scope="{ row }">
          <span>{{ row.createTime | timeFormat }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="isLink" title="是否消耗" width="100">
        <template slot-scope="{ row }">
          <span>{{ row.isLink | isLinkType }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
        background
        size="small"
        :current-page.sync="page"
        :page-size.sync="rows"
        :total="total"
        @page-change="change"
    ></vxe-pager>
    <div class="modal-footer add-btn-box">
      <Button type="primary" style="border-radius: 5px" @click="close">返回</Button>
    </div>
  </div>
</template>
<script>
import $api from "@/apiProvider";
import moment from "moment";

export default {
  props: ['userId'],
  data() {
    return {
      type: 0,
      time: null,
      loading: false,
      hisData: [],
      page: 1,
      rows: 10,
      total: 100
    }
  },
  mounted() {
    this.queryUsesCompRecord();
  },
  filters: {
    isLinkType(val) {
      return val ? '是' : '否'
    }
  },
  methods: {
    change(val) {
      this.page = val.currentPage;
      this.rows = val.pageSize;
      this.queryUsesCompRecord();
    },
    onChange(value) {
      if (value === 0) {
        this.queryUsesCompRecord();
      }
    },
    close(){
      this.$emit('close');
    },
    search() {
      this.page = 1;
      this.queryUsesCompRecord();
    },
    async queryUsesCompRecord() {
      this.loading = true;
      let timeBegin = '';
      let timeEnd = '';
      if (this.type === 0) {
        timeBegin = this.$utils.timestamp(moment().startOf('day').valueOf());
        timeEnd = this.$utils.timestamp(moment().startOf('day').valueOf()) + 86399999;
      } else {
        timeBegin = this.$utils.timestamp(moment(this.time).valueOf());
        timeEnd = this.$utils.timestamp(moment(this.time).valueOf()) + 86399999;
      }
      let res = await $api.seachart.request("queryUsesCompRecord", {
        userId: this.userId,
        timeBegin: timeBegin,
        timeEnd: timeEnd,
        page: this.page,
        rows: this.rows
      });
      this.loading = false;
      if (res.code === 1) {
        this.hisData = res.data.list;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    }
  }
}
</script>
<style scoped>
.modal-footer {
  box-sizing: border-box;
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 94%;
  position: absolute;
  bottom: 0;
}
</style>